import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaBox, FaPlusCircle, FaChartLine, FaUserTie, FaCog } from 'react-icons/fa';
import './MobileNavigation.css';

const MobileNavigationSeller = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  
  // Add/remove mobile nav visibility class on mount/unmount
  useEffect(() => {
    document.body.classList.add('mobile-nav-visible');
    return () => {
      document.body.classList.remove('mobile-nav-visible');
    };
  }, []);

  return (
    <nav className={`mobile-nav seller-nav ${location.pathname === '/login' || location.pathname === '/register' ? 'auth-page' : ''}`}>
      <Link to="/seller/dashboard" className={`nav-item ${isActive('/seller/dashboard') ? 'active' : ''}`}>
        <FaHome className="nav-icon" />
        <span className="nav-label">Dashboard</span>
      </Link>
      <Link to="/seller/products" className={`nav-item ${isActive('/seller/products') ? 'active' : ''}`}>
        <FaBox className="nav-icon" />
        <span className="nav-label">Products</span>
      </Link>
      <Link to="/seller/products/new" className="nav-item add-button">
        <FaPlusCircle className="nav-icon" />
        <span className="nav-label">Add Item</span>
      </Link>
      <Link to="/seller/analytics" className={`nav-item ${isActive('/seller/analytics') ? 'active' : ''}`}>
        <FaChartLine className="nav-icon" />
        <span className="nav-label">Analytics</span>
      </Link>
      <Link to="/seller/profile" className={`nav-item ${isActive('/seller/profile') ? 'active' : ''}`}>
        <FaUserTie className="nav-icon" />
        <span className="nav-label">Profile</span>
      </Link>
    </nav>
  );
};

export default MobileNavigationSeller;
